import {Box, Button, Divider, Drawer, IconButton, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {CopySection, DataInfo} from 'presentation/components';
import Icon from 'presentation/icons';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText, getAddressforMaps} from 'presentation/utils';
import {ContentContainer, StyledAddressContainer, StyledGrid, StyledStack} from './styles';
import {DetailsDrawerProps} from './types';

const {
	address: addressName,
	callToBook,
	openMap,
	drawerTitle,
} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function DetailsDrawer({open, setOpen, unitData}: DetailsDrawerProps) {
	const {isMobile} = useMediaQueries();

	const address = unitData && getAddressforMaps(unitData.address);

	const handleOpenGoogleMaps = () => openGoogleMaps(address?.addressForMaps || '');

	return (
		<Drawer anchor={isMobile ? 'bottom' : 'right'} open={open} onClose={() => setOpen(false)}>
			<ContentContainer>
				<StyledStack>
					<Typography variant="h6">{drawerTitle}</Typography>
					<IconButton onClick={() => setOpen(false)}>
						<Icon name="close-filled" />
					</IconButton>
				</StyledStack>
				<Stack>
					<Typography variant="h6" color="primary" mt={isMobile ? 0 : 2}>
						{formatText(unitData?.name || '')}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{formatText(unitData?.specialty || '')}
					</Typography>
				</Stack>
				<Divider />

				<Typography variant="subtitle2" color="text.secondary">
					{addressName}
				</Typography>

				<Stack gap={1}>
					<StyledAddressContainer>
						<Box maxWidth={328}>
							<DataInfo
								iconName="location-on-filled"
								primaryText={formatText(unitData?.name || '')}
								secondaryText={unitData?.address || ''}
							/>
						</Box>
						<Button
							onClick={handleOpenGoogleMaps}
							variant="outlined"
							endIcon={<Icon name="map" />}>
							{openMap}
						</Button>
					</StyledAddressContainer>
				</Stack>

				{unitData?.phoneNumbers ? (
					<Fragment>
						<Divider />
						<Typography color="primary">{callToBook}</Typography>
						<StyledGrid>
							{unitData?.phoneNumbers.map((item, index) => (
								<CopySection key={index} value={item} />
							))}
						</StyledGrid>
					</Fragment>
				) : null}
			</ContentContainer>
		</Drawer>
	);
}
